import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

const FETCH_DETAIL_API_ID = 'EMPLOYEE/GET_PROGRAM_ORDER_DETAIL_API'

const apiCall = enhancedMakeFetchAction(FETCH_DETAIL_API_ID, ({ id }) => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/employee-program-orders/${id}`,
  method: 'GET'
}))

export default apiCall
